import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import Event, { EVENTS } from '../../util/event';
import { setCookie } from '../../util/cookie';
import { report } from '../../util/dataReporting';
import { filterEmoji } from '../../util/util';
import { LGVChannelID } from '../../util/const';

const pageInfo = {
  prevIdx: 'ref_page',
  nextIdx: 'page_id',
};
export default function Navigations(props) {
  const scrollIntoView = () => {
    window.scrollTo(0, 0);
  };
  const [navigations, setNavigations] = useState([]);
  const [vChannelId, setvChannelId] = useState('');
  const [curFocusIdx, setCurFocusIdx] = useState(1);
  const isChecked = useMemo(() => !!(props.headerflag === 2), [props.headerflag]);

  const isCheckedRef = useRef(isChecked);
  const curFocusIdxRef = useRef(curFocusIdx);
  const vChannelIdRef = useRef(vChannelId);
  const navigationsRef = useRef(navigations);
  // 各个tab停留时间上报
  const stayTime = useRef(0);
  // 这五个值是上下切换时判断的
  const isHaveFilterRef = useRef(null);
  const isHavePosterRef = useRef(null);
  const isHaveHistoryRef = useRef(null);
  const isHaveFirstColumnRef = useRef(null);
  const isHaveColumnRef = useRef(null);
  useEffect(() => {
    isHaveFilterRef.current = props.judgeCondition.isHaveFilter;
  }, [props.judgeCondition.isHaveFilter]);

  useEffect(() => {
    isHavePosterRef.current = props.judgeCondition.isHavePoster;
  }, [props.judgeCondition.isHavePoster]);

  useEffect(() => {
    isHaveHistoryRef.current = props.judgeCondition.isHaveHistory;
  }, [props.judgeCondition.isHaveHistory]);

  useEffect(() => {
    isHaveFirstColumnRef.current = props.judgeCondition.isHaveFirstColumn;
  }, [props.judgeCondition.isHaveFirstColumn]);

  useEffect(() => {
    isHaveColumnRef.current = props.judgeCondition.isHaveColumn;
  }, [props.judgeCondition.isHaveColumn]);
  // 这五个值是上下切换时判断的

  // react跳转函数
  const jumpHistory = useHistory();

  // 切换Tab上报
  const reportEvent = (params) => {
    Object.keys(params).forEach((key) => {
      if (params[key] === 0) {
        setCookie(pageInfo[key], 'linuxtv_account'); // 我的当前页面的id
      } else {
        setCookie(pageInfo[key], `linuxtv_channel_${navigationsRef.current[params[key]].channel.id}`); // 频道页当前页面的分tab曝光（channel_id后台开发）
      }
    });
    if (params.nextIdx !== 0) {
      // 频道页当前页面的分tab曝光上报
      const nowTime = new Date().getTime();
      report({
        attaId: '0cb00063509',
        stayTime: nowTime - stayTime.current,
      });
      stayTime.current = nowTime;
    }
  };

  useEffect(() => {
    setNavigations(props.navigations || []);
    navigationsRef.current = props.navigations || [];
  }, [props.navigations]);

  useEffect(() => {
    setvChannelId(props.vChannelId || '');
    vChannelIdRef.current = props.vChannelId || '';
  }, [props.vChannelId]);

  // 是否是我的页面
  const isMineTab = useRef();
  useEffect(() => {
    isMineTab.current = props.isMineTab;
  }, [props.isMineTab]);

  const moveLeft = () => {
    if (!isCheckedRef.current) return;
    if (curFocusIdxRef.current > 0) {
      const curNavigation = navigationsRef.current[curFocusIdxRef.current - 1];
      reportEvent({
        prevIdx: curFocusIdxRef.current,
        nextIdx: curFocusIdxRef.current - 1,
      });
      setCurFocusIdx(curFocusIdxRef.current - 1);
      Event.emit(EVENTS.HOME_PAGE_CHANGE_CHANNEL, {
        isMine: curFocusIdxRef.current - 1 === 0,
        channelId: curNavigation?.channel?.id,
      });
    }
  };

  const moveRight = () => {
    if (!isCheckedRef.current) return;
    if (curFocusIdxRef.current < navigationsRef.current?.length - 1) {
      const curNavigation = navigationsRef.current[curFocusIdxRef.current + 1];
      reportEvent({
        prevIdx: curFocusIdxRef.current,
        nextIdx: curFocusIdxRef.current + 1,
      });
      setCurFocusIdx(curFocusIdxRef.current + 1);
      Event.emit(EVENTS.HOME_PAGE_CHANGE_CHANNEL, {
        isMine: false,
        channelId: curNavigation?.channel?.id,
      });
    }
  };

  const moveUp = () => {
    if (!isCheckedRef.current) return;
    props.setHeaderflag(1);
  };

  const moveDown = () => {
    if (!isCheckedRef.current) return;
    if (isMineTab.current) {
      props.setHeaderflag(8);
      return;
    }
    if (isHavePosterRef.current) {
      props.setHeaderflag(3);
      return;
    }
    if (isHaveHistoryRef.current) {
      props.setHeaderflag(4);
      return;
    }
    if (isHaveFirstColumnRef.current) {
      props.setHeaderflag(5);
      return;
    }
    if (isHaveFilterRef.current) {
      props.setHeaderflag(6);
      return;
    }
    if (isHaveColumnRef.current) {
      props.setHeaderflag(7);
      return;
    }
    props.setHeaderflag(8);
  };

  const moveClick = () => {
    if (!isCheckedRef.current) return;
    const link = getLink();
    if (link) jumpHistory.push(link);
  };

  const moveExit = () => {
    if (!isCheckedRef.current) {
      props.setHeaderflag(2);
      Event.emit(EVENTS.HOME_PAGE_RETURN_TOP);
    } else if (curFocusIdxRef.current !== 1) {
      setCurFocusIdx(1);
      const curNavigation = navigationsRef.current[1];
      Event.emit(EVENTS.HOME_PAGE_CHANGE_CHANNEL, {
        isMine: false,
        channelId: curNavigation?.channel?.id,
      });
    } else {
      jumpHistory.push('/quitApplication');
    }
  };

  const getLink = () => {
    const curNav = navigationsRef.current && navigationsRef.current[curFocusIdxRef.current];
    report({
      attaId: '0e600058578',
      scene: 'linuxtv_homepage',
      module: 'tab',
      button: curNav?.channel?.id,
    });
    const firstCategory = curNav?.channel?.user_choice?.first_category;
    if (!(firstCategory && firstCategory !== 'All' && curNav.channel.page_type !== 3)) return null;
    const isLG = !!LGVChannelID.includes(vChannelIdRef.current);
    return isLG ? `/filterPageLG/${firstCategory}` : `/filterPage/${firstCategory}`;
  };

  useEffect(() => {
    isCheckedRef.current = isChecked;
  }, [isChecked]);

  useEffect(() => {
    if (isChecked && !props.isLeave) {
      scrollIntoView();
    }
  }, [isChecked, props.isLeave]);

  useEffect(() => {
    curFocusIdxRef.current = curFocusIdx;
  }, [curFocusIdx]);

  useEffect(() => {
    const curNav = navigationsRef.current && navigationsRef.current[curFocusIdxRef.current];
    if (!curNav) return;
    const firstCategory = curNav?.channel?.user_choice?.first_category;
    const isLG = !!LGVChannelID.includes(vChannelIdRef.current);
    if (!(firstCategory && firstCategory !== 'All' && curNav.channel.page_type !== 3)) {
      props.setMoreTabJumpLink(isLG ? '/filterPageLG/0' : '/filterPage/0');
    } else {
      props.setMoreTabJumpLink(isLG ? `/filterPageLG/${firstCategory}` : `/filterPage/${firstCategory}`);
    }
  }, [curFocusIdx, props.navigations]);

  useEffect(() => {
    stayTime.current = new Date().getTime();
    window.onscroll = (event) => {
      const scene = (event.srcElement ? event.srcElement.documentElement.scrollTop : false) || window.pageYOffset;
      const scrollTop = scene || (event.srcElement ? event.srcElement.body.scrollTop : 0);
      const isAddClassTop = Array.from(document.querySelector('.navigation').classList).find(item => item === 'navigation__position__top');
      if (scrollTop > 10 && !isAddClassTop) {
        document.querySelector('.navigation').classList.add('navigation__position__top');
      } else if (scrollTop <= 10) {
        document.querySelector('.navigation').classList.remove('navigation__position__top');
      }
    };
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_LEFT, moveLeft);
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_RIGHT, moveRight);
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_UP, moveUp);
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_DOWN, moveDown);
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_CLICK, moveClick);
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_EXIT, moveExit);
    return () => {
      window.onscroll = null;
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_LEFT, moveLeft);
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_RIGHT, moveRight);
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_UP, moveUp);
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_DOWN, moveDown);
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_CLICK, moveClick);
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_EXIT, moveExit);
    };
  }, []);

  const navigationPos = useMemo(() => {
    const fatherDom = document.querySelector('#navigation');
    const childDom = document.querySelectorAll('#navigation .title')[curFocusIdx];
    if (!!fatherDom && !!childDom) {
      if ((childDom.offsetLeft + childDom.offsetWidth + 90) > fatherDom.offsetWidth) {
        return (childDom.offsetLeft + childDom.offsetWidth + 90) - fatherDom.offsetWidth;
      }
      return 0;
    }
    return 0;
  }, [curFocusIdx]);

  function mouseClick(e, curFocusIdx) {
    e && e.stopPropagation && e.stopPropagation();
    if (curFocusIdxRef.current === curFocusIdx && isCheckedRef.current) {
      moveClick();
      return;
    }
    Event.emit(EVENTS.HOME_PAGE_RETURN_TOP);
    const curNavigation = navigationsRef.current[curFocusIdx];
    reportEvent({
      prevIdx: curFocusIdxRef.current,
      nextIdx: curFocusIdx,
    });
    setCurFocusIdx(curFocusIdx);
    curFocusIdxRef.current = curFocusIdx;
    Event.emit(EVENTS.HOME_UPDATE_STATE, {
      headerflag: 2,
    });
    Event.emit(EVENTS.HOME_PAGE_CHANGE_CHANNEL, {
      isMine: curFocusIdx === 0,
      channelId: curNavigation?.channel?.id,
    });
  }

  return (
    <div
      className="navigation"
      id="navigation"
      style={{ transform: `translateZ(0) translateX(-${navigationPos / global.constants.rootValue}rem)` }}
    >
      {
        navigations.map((item, i) => (
          item.channel.user_choice.first_category && item.channel.user_choice.first_category !== 'All' && item.channel.page_type !== 3 ? (
            <span
              key={i}
              index={i}
              channel-id={item.channel.id}
            >
              <div
                className="title"
                index={i}
                channel-id={item.channel.id}
                onClick={e => mouseClick(e, i)}
              >
                <span
                  className={[
                    'titles',
                    i === curFocusIdx
                      && isChecked
                      ? 'titleh'
                      : '',
                    i === curFocusIdx && !isChecked
                      ? 'titlet'
                      : '',
                  ].join(' ')}
                >
                  {filterEmoji(item.channel.name || '')}
                </span>
                <span
                  className={
                    i === curFocusIdx && !isChecked
                      ? 'title_selected'
                      : ''
                  }
                ></span>
              </div>
            </span>
          ) : (
            <div
              className="title"
              index={i}
              key={i}
              channel-id={item.channel.id}
              onClick={e => mouseClick(e, i)}
            >
              <span
                className={[
                  'titles',
                  i === curFocusIdx
                    && isChecked
                    ? 'titleh'
                    : '',
                  i === curFocusIdx && !isChecked
                    ? 'titlet'
                    : '',
                ].join(' ')}
              >
                {filterEmoji(item.channel.name || '')}
              </span>
              <span
                className={
                  i === curFocusIdx && !isChecked
                    ? 'title_selected'
                    : ''
                }
              ></span>
            </div>
          )
        ))
      }
    </div>
  );
}
